<template>
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
        <div>
        <nav-bar/>
        <b-container class="position-relative strata-table" fluid>
            <div class="main-panel">
                <div>
                    <h2 class="head-title" v-if="workOrder">Work Orders</h2>
                    <h2 class="head-title" v-else>Quotes</h2>
                    <b-row class="pb-3">
                        <b-col md="6" sm="12" class="mb-3">
                            <b-button
                                v-if="workOrder"
                                class="mt-2"
                                :to="{ name: 'manager-workorder-edit', params: { id: 'new', step: 1 } }"
                                variant="primary">Create Work Order
                            </b-button>
                             <b-button
                                v-else
                                class="mt-2"
                                :to="{ name: 'manager-quote-edit', params: { id: 'new', step: 1 } }"
                                variant="primary">Create Quote
                            </b-button>
                        </b-col>

                        <b-col class="d-flex">
                            <b-form @submit.prevent inline>
                                <b-row>
                                    <b-col lg="4" md="6" sm="4" class="mb-3">
                                        <label class="sr-only" for="filterManager">Name</label>
                                        <!-- <treeselect
                                            v-model="filterManager"
                                            :style="{'margin-right': '9px','width':'100%'}"
                                            :multiple="false"
                                            placeholder="All Manager"
                                            :defaultOptions="options"
                                            id="filterManager"
                                            :async="true"
                                            :load-options="loadFilterManagerOptions"
                                            :clearable="true"
                                            :open-on-click="true"
                                            @input="filter(1)"
                                        /> -->
                                        <treeselect
                                            :multiple="false"
                                            :options="filterManagerOptions"
                                            placeholder="Select company..."
                                            v-model="filterManager"
                                            :style="{'width':'100%'}"
                                            @input="filter(1)"

                                        />
                                    </b-col>

                                    <b-col lg="4" md="6" sm="4" class="mb-3">
                                        <label class="sr-only" for="filterStatus">Status</label>
                                        <b-form-select
                                            style="width:100%;padding: 0.4rem 0.75rem;height: 3.9rem;"
                                            v-model="filterStatus"
                                            class="mb-2 mr-sm-2 mb-sm-0"
                                            id="filterStatus"
                                            :options="workOrder ? workOrderStatusOption:quoteStatusOption"
                                            @change="filter(1)"
                                        ></b-form-select>

                                          <!-- <b-form-select
                                            v-if="workOrder"
                                            style="width:100%;padding: 0.4rem 0.75rem;height: 3.9rem;"
                                            v-model="filterStatus"
                                            class="mb-2 mr-sm-2 mb-sm-0"
                                            id="filterStatus"
                                            :options="workOrderStatusOption"
                                            @change="filter(1)"
                                        ></b-form-select> -->
                                    </b-col>

                                    <b-col lg="4" md="12" sm="4">
                                        <div class="position-relative f-b">
                                            <i class="fas fa-search search-icon"></i>
                                        <b-form-input
                                                style="width: 100%; height: 3.8rem !important;"
                                                class="mb-2 mb-sm-0"
                                                placeholder=""
                                                v-model="filterQuery"
                                                @change="filter(1)"
                                            ></b-form-input>
                                        </div>
                                    </b-col>

                                </b-row>
                            </b-form>
                        </b-col>

                    </b-row>
                    <div class="datagrid mb-4 mt-4">
                        <div class="datagrid-body">
                            <b-table
                                :busy="this.$root.loading"
                                :items="this.workOrder? workOrderTableItems : quoteTableItems"
                                :fields="this.workOrder? workOrderTableFields : quoteTableFields"
                                sort-icon-left
                                hover
                                responsive
                                show-empty
                            >
                                <template v-slot:cell(status) = "row">
                                    <div v-if="workOrder">
                                        <p v-if="row.item.status == 'open' " style="display: inline-block;font-size: 14px;color: #00BA88; margin-bottom: 0;">Open</p>
                                        <p v-if="row.item.status == 'draft'" style="background-color:rgb(216 195 43);display: inline-block;padding: 3px 6px;font-size: 12px;color: white; margin-bottom: 0;">Draft</p>
                                        <p v-if="row.item.status == 'in-progress'" style="display: inline-block;font-size: 12px;color: #00AB54; margin-bottom: 0;">In Progress</p>
                                        <p v-if="row.item.status == 'granted'" style="display: inline-block;font-size: 12px;color:#F2994A; margin-bottom: 0;">Awarded</p>
                                        <p v-if="row.item.status == 'verify-completed'" style="display: inline-block;font-size: 12px;color:rgb(12 203 9); margin-bottom: 0;">Awaiting Verification</p>
                                        <p v-if="row.item.status == 'completed'" style="display: inline-block;font-size: 12px;color:rgb(39 132 187); margin-bottom: 0;">Completed</p>
                                    </div>
                                     <div v-if="!workOrder">
                                        <p v-if="row.item.status == 'open'" style="display: inline-block;font-size: 14px;color: #00BA88;margin-bottom:0;">Open</p>

                                        <p v-if="row.item.status == 'active'" style="display: inline-block;padding: 3px 6px;font-size: 14px;color: #5F2EEA;margin-bottom: 0;">Active</p>

                                        <!-- active-due-quotes -->
                                         <p v-if="row.item.status == 'active-due-quotes'" style="display: inline-block;font-size: 14px;color: #4682b4;margin-bottom:0;">Active {{ row.item.remaningdays == 1 ?  '( Expiring in '+row.item.remaningdays + ' day )' : row.item.remaningdays > 1 ?  '( Expiring in '+row.item.remaningdays + ' days )' : '(Expiring Today)'}}</p>

                                        <p v-if="row.item.status == 'pending-approval'" style="display: inline-block;font-size: 14px;color: rgb(195 18 227 / 78%);margin-bottom:0;">Pending Approval</p>

                                        <!-- For Open due quotes -->
                                        <p v-if="row.item.status == 'open-due-quotes'" style="display: inline-block;font-size: 14px;color: #00BA88;margin-bottom: 0;">Open {{ row.item.remaningdays == 1 ?  '( Expiring in '+row.item.remaningdays + ' day )' : row.item.remaningdays > 1 ?  '( Expiring in '+row.item.remaningdays + ' days )' : '(Expiring Today)'}}</p>

                                         <!-- For Active due quotes -->
                                        <p v-if="row.item.status == 'due'" style="background-color:#4682b4;display: inline-block;padding: 3px 6px;font-size: 12px;color: white;margin-bottom:0;">Due Soon {{ row.item.remaningdays > 0 ?  '('+row.item.remaningdays + ' Days left)' : '(Expiring Today)'}}</p>

                                        <p v-if="row.item.status == 'over-due'" style="display: inline-block;font-size: 14px;color: rgb(233 22 22);margin-bottom:0;">Overdue {{ '(' + row.item.remaningdays + ' Days Passed)'}}</p>

                                        <p v-if="row.item.status == 'draft'" style="display: inline-block;padding: 3px 6px;font-size: 12px;color:rgb(230 203 11);margin-bottom:0;">Draft</p>
                                        <p v-if="row.item.status == 'completed'" style="display: inline-block;font-size: 14px;color: #ED2E7E;">Completed</p>
                                    </div>
                                    </template>
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner
                                            class="align-middle"
                                            :variant="'primary'"
                                        ></b-spinner>
                                    </div>
                                </template>
                                <template v-slot:cell(action)="row">
                                    <router-link
                                    v-if="workOrder"
                                        :to="{
                                            name: 'manager-workorder-view',
                                            params: { id: row.item.id },
                                            query: {manager_id : filterManager}
                                        }"
                                    >View
                                    </router-link>
                                     <router-link
                                        v-else
                                        :to="{
                                            name: 'manager-quote-view',
                                            params: { id: row.item.id },
                                            query: {manager_id : filterManager}
                                        }"
                                    >View
                                    </router-link>
                                </template>
                                   <template #empty class="text-center">
                                        No Data Found
                                    </template>
                            </b-table>

                        </div>
                        <div class="datagrid-footer" v-if="lastPage > 1">
                            <b-pagination
                                pills
                                align="right"
                                :total-rows="total"
                                v-model="currentPage"
                                :page-count="lastPage"
                                :per-page="perPage"
                                :hide-goto-end-buttons="true"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
         <footer-component></footer-component>
        </b-container>
    </div>
    </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "./../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
    components: {
        NavBar,
        FooterComponent,
        Treeselect
    },
    props: {
        filterStatus: String,
        workOrder: String,
    },
    data() {
        return {
            currentPage: 1,
            total: 0,
            perPage: 50,
            lastPage: 1,
            quoteTableItems: [],
            workOrderTableItems: [],
            quoteTableFields: [
                {key: 'date', sortable: true, label: 'Creation Date'},
                {key: 'job_ID', sortable: true},
                {key: 'job_Title', sortable: true},
                {key: 'due_date', sortable: true},
                {key: 'strata_plan_ID', sortable: true},
                {key: 'manager', sortable: true},
                {key: 'library', sortable: true},
                {key: 'status', sortable: true},
                {key: 'action', sortable: false}
            ],
            quoteStatusOption: [
               { value: 'all', text: 'All' },
                { value: 'open', text: 'Open' },
                { value: 'active', text: 'Active' },
                { value: 'pending-approval', text: 'Pending Approval' },
                { value: 'due-soon', text: 'Due Soon' },
                { value: 'overdue', text: 'Overdue' },
                { value: 'draft', text: 'Draft' },
                { value: 'completed', text: 'Completed' },
            ],
            workOrderTableFields: [
                {key: 'date', sortable: true, label: 'Creation Date'},
                {key: 'work_order_ID', sortable: true},
                {key: 'job_Title', sortable: true},
                {key: 'strata_plan_ID', sortable: true},
                {key: 'manager', sortable: true},
                {key: 'Contractor_Co.', sortable: true},
                {key: 'status', sortable: true},
                {key: 'action', sortable: false}
            ],
            workOrderStatusOption: [
                { value: 'all', text: 'All' },
                { value: 'open', text: 'Open' },
                { value: 'manager-awarded-workorders', text: 'Awarded'},
                { value: 'manager-inprogress-workorders', text: 'In Progress' },
                { value: 'manager-awaiting-verification-workorders', text: 'Awaiting Verfication' },
                { value: 'manager-cancelled-workorders', text: 'Cancelled' },
                { value: 'manager-completed-workorders', text: 'Completed'},
                { value: 'manager-hold-workorders', text: 'Hold'},
            ],
            filterQuery: "",
            filterManager: this.$store.state.authenticatedUserData.user.id,
            filterManagerOptions: [],
            // filterStatus: "all",
            // options: [
            //     {
            //     id: this.$store.state.authenticatedUserData.user.id,
            //     label: this.$store.state.authenticatedUserData.user.full_name + ' (My Quote)'
            //     },
            // ],
        };
    },
    mounted() {
        this.filter(1);
        this.loadOrganizationManager();
        // this.loadFilterManagerOptions();
    },
    methods: {
        filter(page = 1) {
            this.$root.$data.bsLoader = true;
            axios
                .post("api/manager/quote/filter", {
                    page: page,
                    per_page: 10,
                    filter_query: this.filterQuery,
                    filter_manager_id: this.filterManager,
                    filter_status: this.filterStatus,
                    jobType : this.workOrder ? 'work-order' : 'quote'
                })
                .then((response) => {
                    this.currentPage = response.data.current_page;
                    this.total = response.data.total;
                    this.perPage = response.data.per_page;
                    this.lastPage = response.data.last_page;

                    if(this.workOrder)
                    {
                            this.workOrderTableItems = _.map(response.data.quotes, function (quote) {
                            if(quote.status_parsed == "open-due-quotes" || quote.status_parsed == "active-due-quotes"){
                                var dueDate = moment(quote.due_date).add(1, 'days');
                                var currentDate = moment();
                                var subtractDate= dueDate.diff(currentDate, 'days') // 1
                            }

                            if(quote.status_parsed == 'over-due'){
                                var dueDate = moment(quote.due_date);
                                var currentDate = moment();
                                var subtractDate= currentDate.diff(dueDate, 'days') // 1
                            }

                            return {
                                id: quote.id,
                                remaningdays: subtractDate ? subtractDate : 0,
                                date: moment(quote.issue_date).format("D MMM YYYY"),
                                job_Title:quote.job_title,
                                work_order_ID: quote.organization_id,
                                strata_plan_ID: quote.strata_plan.type + '-' + quote.strata_plan.strata_plan_number,
                                manager: quote.strata_plan.manager.first_name + " " + quote.strata_plan.manager.last_name,
                                'Contractor_Co.': quote.awarded_business ? quote.awarded_business.company_name : '',
                                status: quote.status_parsed,
                                action: "",
                            };
                        });
                    }else
                    {
                        this.quoteTableItems = _.map(response.data.quotes, function (quote) {
                            if(quote.status_parsed == "open-due-quotes" || quote.status_parsed == "active-due-quotes"){
                                var dueDate = moment(quote.due_date).add(1, 'days');
                                var currentDate = moment();
                                var subtractDate= dueDate.diff(currentDate, 'days') // 1
                            }

                            if(quote.status_parsed == 'over-due'){
                                var dueDate = moment(quote.due_date);
                                var currentDate = moment();
                                var subtractDate= currentDate.diff(dueDate, 'days') // 1
                            }

                            return {
                                id: quote.id,
                                remaningdays: subtractDate ? subtractDate : 0,
                                date: moment(quote.issue_date).format("D MMM YYYY"),
                                job_ID: quote.organization_id,
                                job_Title:quote.job_title,
                                due_date: quote.due_date ? moment(quote.due_date).format("D MMM YYYY") : '',
                                strata_plan_ID: quote.strata_plan.type + '-' + quote.strata_plan.strata_plan_number,
                                manager: quote.strata_plan.manager.first_name + " " + quote.strata_plan.manager.last_name,
                                // library: "Documents (" +quote.media.length + ")",
                                status: quote.status_parsed,
                                action: "",
                            };
                        });
                    }
                    this.$root.$data.bsLoader = false;
                }).catch((err) => {
              this.$root.$data.bsLoader = false;
            });
        },
        loadOrganizationManager() {
            axios
                .post("api/content/getReplyToManagers")
                .then((response) => {
                    this.filterManagerOptions = response.data.business_users.map((businessUser) => {
                        return {
                            id: businessUser.id,
                            label: businessUser.first_name + ' ' + businessUser.last_name,
                        };
                    });

                    //Adding all option at the beginnning of select option
                    this.filterManagerOptions.unshift({
                        id: 'all',
                        label: 'All'
                    });
                });

        },

    },

    watch: {
        currentPage: {
            handler: function (value) {
                this.filter(value);
            },
        },
        $route($to, $from) {
            if($to.name == 'manager-quotes' || $to.name == 'manager-workorder'){
                this.filter(1);
            }
        },
    }
}
</script>

<style scoped>
    .body-wrapper
    {
        background-color: #F7F7FC;
        height: 100vh;
    }
    h2.head-title
    {
        font-size: 28px;
        font-weight: 600;
    }
    .vue-treeselect__control
    {
        padding: 1.08rem 0.75rem !important;
    }

    footer {
        margin-top: 9rem;
        margin-bottom: 1rem;
    }

</style>



